import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './pages';
import '@/utils/erdura';
import '@/utils/i18n';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
